<template>
  <div style="border: 1px solid #ccc">
    <!-- <b-button @click="saveData">Guardar</b-button> -->
    <div class="table-title">
      <h3 class="titulo-c3">Cuadro 4</h3>
      <h3 class="titulo-c3">{{ title }}</h3>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Denominación</th>
          <th scope="col">Ley Inicial</th>
          <th scope="col">Presupuesto final</th>
          <th scope="col">Devengado</th>
          <th scope="col">Observaciones</th>
          <th scope="col">
            <b-button class="button-add" @click="addItemListSix">+</b-button>
          </th>
        </tr>
      </thead>
      <tbody>
        <Row
          v-for="(item, index) in itemList"
          :key="index"
          :removeItem="removeItem"
          :objTest="item"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import Row from "./Row.vue";
export default {
  props: ["addItemListSix", "itemList", "removeItem"],
  components: {
    Row,
  },
  data() {
    return {
      title: `Ejecución de Aspectos Relevantes Contenidos en el Presupuesto ${process.env.VUE_APP_ANIO}`,
    };
  },

  mounted() {},
};
</script>

<style scoped>
.titulo-c3 {
  font-size: 1.1rem;
  color: #2b425f;
  font-weight: bold;
  margin: 0;
  text-align: center;
}
.table > tbody,
.table > thead {
  vertical-align: middle;
}
.button-add {
  background: #25a2b7 !important;
  color: white !important;
  border: none;
  width: 25px;
  height: 25px;
  border-radius: 14px;
  padding: 0 !important;
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 0;
}

.table-title {
  background: #efefef;
}
</style>
